<router-outlet *ngIf="!tooSmall"></router-outlet>

<div *ngIf="tooSmall">
  <p i18n="index smartphoneWarning|Warning that appears on smartphones only@@vorsorgeSmartphoneWarning">Um den
    Rentenrechner verwenden zu können, wechseln Sie bitte auf die Desktopversion.</p>
</div>
